module.exports = __webpack_public_path__ + "assets/img/releaseFiles.33878dee.svg";